export enum ApiCallResultStatus {
  DEFAULT,
  LOADING,
  FAILED,
  SUCCESS,
}

/**
 * Util type for tracking status of a specific request
 */
export type ApiRequestStatus = {
  /**
   * Unique identifier for the request
   */
  requestId: string;
  /**
   * Status of the request
   */
  status: ApiCallResultStatus;
};

export function wasApiCallMade(status: ApiCallResultStatus | undefined): boolean {
  return status !== undefined && status !== ApiCallResultStatus.DEFAULT;
}

export function isApiCallComplete(status: ApiCallResultStatus | undefined): boolean {
  return status !== undefined && status !== ApiCallResultStatus.DEFAULT && status !== ApiCallResultStatus.LOADING;
}

export function isApiCallsComplete(statuses: ApiCallResultStatus[]): boolean {
  return statuses !== undefined && (statuses.every((x) => isApiCallComplete(x)) || statuses.length === 0);
}

export function isApiCallFailed(status: ApiCallResultStatus | undefined): boolean {
  return status === ApiCallResultStatus.FAILED;
}

export function isApiCallSuccess(status: ApiCallResultStatus | undefined): boolean {
  return status === ApiCallResultStatus.SUCCESS;
}
